@if (isRave() ) {
  <div class="search-result">
    <div class="form-table-container">
      <table id="rave-history-table" class="table is-fullwidth is-striped" role="grid">
        <thead>
          <tr class="is-selected" role="row">
            @for (column of columns; track column) {
              @if (column.display) {
                <th class="table-header" [mcTableSorting]="config" [column]="column"
                  title="{{column.title}}" (sortChanged)="onChangeTable($event)" ngClass="{{column.className || ''}}">
                  <span> {{column.title}}</span>
                  @if (config && column.sort) {
                    <span class="sort is-text-centered">
                      @if (column.sort === 'desc') {
                        <span>
                          <i class="fas fa-sort-down"></i>
                        </span>
                      }
                      @if (column.sort === 'asc') {
                        <span>
                          <i class="fas fa-sort-up"></i>
                        </span>
                      }
                    </span>
                  }
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (row of postProcessingHistoryRecords; track row) {
            <tr>
              <td>
                <span>{{row.raveGroup}}</span>
              </td>
              <td>
                <span>{{row.attribute}}</span>
              </td>
              <td>
                <span>{{row.action | titlecase}}</span>
              </td>
              <td>
                <span>{{row.status | titlecase}}</span>
              </td>
              <td>
                <span>{{row.errorMessage}}</span>
              </td>
              <td>
                <span>{{row.raveFormName}}</span>
              </td>
              <td>
                <span>{{row.dateTime | date:'MM/dd/yyyy h:mm:ss a'}}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}